// Horizontal breathing room between a node handle and where the dragged edge
// breaks vertically, so the line doesn't hug the output/input of the node.
export const EDGE_HANDLE_OFFSET = 20;

export const getControlPointPath = ({ sourceX, sourceY, targetX, targetY, controlPoint }) => {
  // Leave the output handle horizontally before breaking vertically so the line
  // doesn't hug the node. The path must still pass through the control point
  // (the draggable label), otherwise the line detaches from the box when dragged.
  const sourceStubX = sourceX + EDGE_HANDLE_OFFSET;

  return [
    `M ${sourceX},${sourceY}`,
    `H ${sourceStubX}`,
    `V ${controlPoint.y}`,
    `H ${controlPoint.x}`,
    `V ${targetY}`,
    `H ${targetX}`,
  ].join(' ');
};
